export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Footer.vue?vue&type=template&id=e434fdce&"


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/Footer.vue?vue&type=template&id=e434fdce&
// module id = null
// module chunks = 